// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".month-item[data-v-bc9d86e6]{padding:10px 25px;border-radius:16px;background:#f0f0f0;cursor:pointer;white-space:nowrap;transition:all .2s ease;font-size:23px}.month-item.selected[data-v-bc9d86e6]{background:#6d1106;color:#fff}@media(hover:hover){.month-item[data-v-bc9d86e6]:hover{background:#6d1106;color:#fff}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
